<h3>Scan pro Assignment <button type="button" (click)="CloseModal()" class="btn btn-default bold float-right">Close</button></h3>
<hr />
<div class="row">
    <div class="col-sm-12">
        <form [formGroup]="scanProForm" (submit)="scanProAssignment()">
            <div class="row">
                <div class="col-sm-8 right-border">
                    <label class="form-label" >Scan pro*</label>
                    <mat-select placeholder="Scan pro" formControlName="scan_pro">
                        <mat-option value="">Select Scan pro</mat-option>
                        <mat-option [value]="pro.id" *ngFor="let pro of scanProUser">{{pro.name}}</mat-option>
                    </mat-select>
                    <div *ngIf="submitted && f.scan_pro.errors" class="invalid-feedback">
                        <div *ngIf="f.scan_pro.errors.required">Scan pro is required</div>
                    </div>
                </div>
                <div class="col-sm-8 mt-2"></div>
            </div>
            <div class="card-footer">
                <button type="submit" [disabled]="loading" class="btn btn-primary"><i *ngIf="loading"
                    class="fa fa-spin fa-spinner"></i> Submit</button>
            </div>
        </form>
    </div>

</div>